import { render, staticRenderFns } from "./ui-pagination.vue?vue&type=template&id=7a10022b&scoped=true"
import script from "./ui-pagination.vue?vue&type=script&lang=js"
export * from "./ui-pagination.vue?vue&type=script&lang=js"
import style0 from "./ui-pagination.vue?vue&type=style&index=0&id=7a10022b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10022b",
  null
  
)

export default component.exports